import React, { forwardRef } from 'react';
import type { OutlinedInputProps } from '@mui/material';
import { OutlinedInput as OutlinedInputMUI } from '@mui/material';

import { SHAPE_CIRCULAR, SHAPE_ROUNDED, SHAPE_SQUARE } from '@/mui/constants';

import { omitUndefinedProps } from '@/mui/helpers';

import { CUSTOM_ATTRIBUTE_SHAPE } from './OutlinedInput.api';

type Props = {
  shape?: typeof SHAPE_SQUARE | typeof SHAPE_ROUNDED | typeof SHAPE_CIRCULAR;
};

const OutlinedInput = forwardRef<HTMLElement, OutlinedInputProps & Props>((props, ref) => (
  <OutlinedInputMUI
    {...omitUndefinedProps({
      ...props,
      shape: undefined,
      [CUSTOM_ATTRIBUTE_SHAPE]: props.shape,
    })}
    ref={ref}
  />
));

OutlinedInput.displayName = 'OutlinedInput';

export default OutlinedInput;
